<template>
  <b-card>
    <div v-if="loading" class="text-center py-3">
      <b-spinner variant="primary" />
    </div>
    <b-form v-else>
      <b-row>
        <b-col cols="12">
          <p class="font-weight-bolder border-bottom">Deposit Match Defaults</p>
          <b-form-group>
            <label class="font-weight-bold" for="bonus-expired-days"
              >Default Days for Bonus Bets to Expire</label
            >
            <b-form-input
              id="bonus-expired-days"
              v-model.number="form.bonusExpiredDays"
              type="number"
              min="1"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <div class="d-flex justify-content-end align-items-center">
            <b-button variant="success" :disabled="saving" @click="handleSave">
              <b-spinner v-if="saving" small class="mr-50" />
              <feather-icon v-else icon="SaveIcon" />
              Save Changes</b-button
            >
          </div>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BSpinner,
} from "bootstrap-vue";
import { mapState, mapActions } from "vuex";
import useToastHandler from "@/services/toastHandler";

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BSpinner,
  },
  data() {
    return {
      form: {
        bonusExpiredDays: 30,
      },
    };
  },
  computed: {
    ...mapState("settings/marketing-promo", ["loading", "saving"]),
  },
  created() {
    this.fetchSettings();
  },
  methods: {
    ...mapActions("settings/marketing-promo", [
      "getMarketingPromoSettings",
      "updateMarketingPromoSettings",
    ]),
    async fetchSettings() {
      const data = await this.getMarketingPromoSettings();
      if (data?.value != null) {
        this.form.bonusExpiredDays = data.value;
      }
    },
    async handleSave() {
      const result = await this.updateMarketingPromoSettings(
        this.form.bonusExpiredDays
      );
      if (result) {
        this.showToastSuccess(
          "Settings saved",
          "Marketing & Promo settings updated successfully."
        );
      }
    },
  },
  setup() {
    const { showToastSuccess } = useToastHandler();
    return { showToastSuccess };
  },
};
</script>
